import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VerticalNavComponent } from '../vertical-nav/vertical-nav.component';
import { NavigationService } from '../../services/navigation.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'lib-app-layout',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './app-layout.component.html',
  styleUrl: './app-layout.component.scss'
})
export class AppLayoutComponent implements OnInit, OnDestroy {

  @Input() appTitle = 'Smart Parking';
  private destroy$ = new Subject<void>();
  isHandset = false;
  isNavCollapsed = false;
  private navigationService = inject(NavigationService);
  private breakpointObserver = inject(BreakpointObserver);

  ngOnInit(): void {
    this.navigationService.getCollapseState().subscribe(collapsed => {
      this.isNavCollapsed = collapsed;
    });
    this.setupBreakpoints();
  }

  private setupBreakpoints(): void {
    this.breakpointObserver.observe([Breakpoints.Handset])
      .pipe(
        takeUntil(this.destroy$),
        map(result => result.matches)
      )
      .subscribe(isHandset => {
        this.isHandset = isHandset;
        // Always collapse on mobile devices
        if (isHandset) {
          this.navigationService.setCollapse(true);
        }
      });
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}